import { Layout } from 'antd';
import { Content } from "antd/es/layout/layout";
import CardInfo from "./CardInfo";

function LayoutHome({ cardInfo, notiTab, request }) {
    return (
        <Layout style={{ width: "100%", backgroundColor: 'transparent' }}>
            <Content style={{ backgroundColor: 'transparent' }}>
                <CardInfo
                    {...cardInfo}
                    {...notiTab}
                    getPaddingList={request.getPaddingList}
                    getPendingTotal={request.getPendingTotal}
                />
            </Content>
        </Layout>
    );
}

export default LayoutHome;